<template>
  <div class="product-card">
    <div class="product-info">
      <div class="product-image">
        <img :src="item.image_url" />
      </div>
      <div class="product-details">
        <!-- <div class="badge-product-wrp">
          <span v-for="(i, index) in 2" :key="index" class="badge-product mr-2"
            >TOP SELLING</span
          >
        </div> -->
        <div class="name">
          {{ item.item_name }}
        </div>
        <!-- <div class="discount">฿189</div> -->
        <div class="price-range">{{ item.price_range }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tooltipText: "",
      imageUrl: "https://cf.shopee.co.th/file/sg-11134201-7rdxg-mcagrnb0awt510"
    };
  }
};
</script>

<style lang="scss" scoped>
.product-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  .product-info {
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;

    .product-image {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      overflow: hidden;
      border: 1px solid #e8e7e7;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .product-details {
      .badge-product-wrp {
        .badge-product {
          padding: 0px 5px;
          background-color: #f1f1f1;
          color: #2c3e50;
          font-weight: 600;
          font-size: 12px;
        }

        span:first-child {
          background-color: #fbefe2;
          color: #f09540;
        }

        span:last-child {
          background-color: #d9d4ef;
          color: #8f20c6;
        }
      }

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }

      .discount {
        text-decoration: line-through;
        color: #9c9c9c;
        font-size: 12px;
      }

      .price-range {
        color: #8f20c6;
        font-weight: 600;
      }
    }
  }

  .product-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
